import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

import ActionBanner from '../ActionBanner';

const DeliveryMethodLibre = ({ chooseLibre, actionBanner = '', badge = '', popupRef = null, sourceToLibre = {} }) => {
    const handleClick = () => {
        if (actionBanner && popupRef?.current) {
            popupRef.current?.open(<ActionBanner actionBanner={actionBanner} popupRef={popupRef} handleClick={chooseLibre} />);
        } else {
            chooseLibre();
        }
    };

    return (
        <Panel type="div" onClick={handleClick} isHoverable negativeMargin>
            <DiskBadgeWrapper>
                <DiskBadge variant="secondary" iconName="paysend-rounded" />
            </DiskBadgeWrapper>
            <PanelContent>
                <PanelRow>{sourceToLibre.sourceName}</PanelRow>
                <PanelRow>
                    <Text size="secondary" color="secondary">
                        {sourceToLibre.sourceList}
                    </Text>
                </PanelRow>
            </PanelContent>
            {badge ? (
                <PanelRightBlock>
                    <Badge variant="primary" caption={badge} />
                </PanelRightBlock>
            ) : null}
        </Panel>
    );
};
DeliveryMethodLibre.propTypes = {
    sourceToLibre: PropTypes.object,
    chooseLibre: PropTypes.func,
    actionBanner: PropTypes.string,
    badge: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};
export default DeliveryMethodLibre;
